import { useContext, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import { authService } from '../services/authService';

export const useLogout = () => {
    const { setUser } = useContext(AuthContext);
    const navigate = useNavigate();

    const handleLogout = useCallback(async () => {
        try {

            // Appeler le service d'authentification
            await authService.logout();

            // Mettre à jour le contexte
            setUser(null);

            // Rediriger vers l'accueil
            navigate('/');

        } catch (error) {
            console.error('[useLogout] Erreur:', error);
            throw error;
        }
    }, [setUser, navigate]);

    return {
        handleLogout,
    };
};
